import React, { useState } from "react";
//import Switch from 'react-bulma-switch';
import RoundedSwitch from "../shared/rounded-switch";
import Price from "./price";
import PricesTermsAndConitions from "./prices-t-and-c";
import './prices.scss';

const Prices = ({ prices, currencySymbol, registerUrl, hasTax }: any) => {

    const pricingPlans = [
        { name: "Free", description: "To try it out", price: prices[0].price, taxAmount: prices[0].taxAmount, maxFilms: 1, maxCollaboratorsPerFilm: 3, maxBytes: 536870912, includes: ["1 film", "3 users per film", "500MB storage"] },
        { name: "No-budget", description: "For the basics", price: prices[1].price, taxAmount: prices[1].taxAmount, maxFilms: 2, maxCollaboratorsPerFilm: 10, maxBytes: 1073741824, includes: ["2 active films", "10 users per film", "1GB storage"] },
        { name: "Indie", description: "For teams", price: prices[2].price, taxAmount: prices[2].taxAmount, maxFilms: 5, maxCollaboratorsPerFilm: null, maxBytes: 5368709120, includes: ["5 active films", "Unlimited users per film", "5GB storage"] },
        { name: "Studio", description: "For production companies", price: prices[3].price, taxAmount: prices[3].taxAmount, maxFilms: 10, maxCollaboratorsPerFilm: null, maxBytes: 10737418240, includes: ["10 active films", "Unlimited users per film", "10GB storage"] }
    ];

    const [includeTax, setIncludeTax] = useState(true);

    return (
        <section id="pricing">
            <div className="is-centered prices">
                <div className="marketing-titles prices-title">Our pricing plans</div>

                <div className="prices-container-container">
                    {hasTax && <div className="field has-text-centered">
                        <RoundedSwitch
                            label="Include tax"
                            checked={includeTax}
                            onChange={() => setIncludeTax(!includeTax)}
                        />
                    </div>}
                    <div className="prices-container">
                        {pricingPlans.map((plan, index) => (
                            <Price
                                key={index}
                                pricingPlan={index}
                                plan={plan}
                                name={plan.name}
                                description={plan.description}
                                price={plan.price}
                                currency={currencySymbol}
                                includes={plan.includes}
                                registerUrl={registerUrl}
                                includeTax={includeTax} />
                        ))}
                    </div>
                </div>
                <PricesTermsAndConitions />
            </div>
        </section >
    )
}

export default Prices;